module.exports = __webpack_public_path__ + "img/depmap_svg_V53.72ed7b14.svg";